/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_So_Tien_DescInputs */

const vi_station_voice_ph_so_tien_desc = /** @type {(inputs: Station_Voice_Ph_So_Tien_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền (đọc thành chữ)`)
};

/**

* @param {Station_Voice_Ph_So_Tien_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_so_tien_desc = /** @type {((inputs?: Station_Voice_Ph_So_Tien_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_So_Tien_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_so_tien_desc(inputs)
});